import { Injectable } from '@angular/core';
import { DomainTerminology } from 'app/viewmodels/configuration/domain-terminology';
import { ConfigService } from '../config.service';
import { Domain } from '../domain';
import { RemoteConfiguration } from '../remote-config';
import { SystemSettings } from '../system-configuration/system-settings';

@Injectable({
  providedIn: 'root',
})
export class DomainTerminologyTranslationService {

  public static keySeparator = '.';

  public domainTerminologyItems: DomainTerminology[];

  private terminologyData: { [key: string]: any } = {};

  constructor(private systemSettings: SystemSettings, private configService: ConfigService) {
    this.systemSettings.domainChanged.subscribe((domain: Domain) => this.initData(domain));
  }

  public init() {
    this.initData(this.systemSettings.domain);
  }

  public translate(
    key: string,
    params?: any,
  ): string | null {
    if (this.terminologyData) {
      const value = key.split(DomainTerminologyTranslationService.keySeparator).reduce((acc, cur) => (acc && acc[cur]) || key, this.terminologyData);
      return this.addParams(value, params);
    }
    return key;
  }

  private addParams(value: string, params: any): string {
    const replacedValue = value.replace(/{{\s?([^{}\s]*)\s?}}/g, (substring: string, parsedKey: string) => {
      const replacer = params[parsedKey];
      return replacer !== undefined ? replacer : substring;
    });
    return replacedValue;
  }

  private initData(domain: Domain) {
    const remoteConfiguration: RemoteConfiguration = this.configService.getRemoteConfiguration();
    if (remoteConfiguration.domainTerminologyItems) {
      this.terminologyData = remoteConfiguration.domainTerminologyItems.find(item => item.domain === domain).terminologyData;
    }
  }
}
